export default __webpack_public_path__ + "images/pictograms/chrome.svg?9b561184a954b64e6ff52e6ccc13280b68c8c78ed2ee991f84ae4b62f0010f30";